import { staticText } from '../../utils/translations/staticText';

// Strings from the CMS-1609 Localisation table. zh = MoneyHero HK text
// (zh-hk falls back to the zh language key); zh-tw overrides for Money101.
export const TRANSLATIONS = staticText({
  default_title: {
    _: 'See similar products other customers have viewed',
    zh: '其他客戶也查看了這些產品',
    'zh-tw': '其他用戶也查看了這些產品',
  },
  apply_now: {
    _: 'Apply Now',
    zh: '立即申請',
  },
});
